/* src/app/feature-info/feature-info.component.css */
:host ::ng-deep {
  font-size: 14px;
  line-height: 1.3;
  font-family: inherit !important;
}
:host ::ng-deep .featureInfoDialog.p-dialog {
  width: min(1180px, 96vw);
  height: 96vh;
  min-width: 520px;
  min-height: 760px;
  max-width: 96vw;
  max-height: 96vh;
  border-radius: 12px;
  overflow: visible !important;
  display: flex;
  flex-direction: column;
}
:host ::ng-deep .featureInfoDialog.p-dialog .p-dialog-header {
  background: #ffffff;
  border-bottom: 1px solid #d3d3d3;
  padding: 10px 14px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:host ::ng-deep .featureInfoDialog.p-dialog .p-dialog-title {
  color: #2b2b2b;
  font-weight: 600;
}
:host ::ng-deep .featureInfoDialog.p-dialog .p-dialog-header .p-dialog-header-actions button {
  background: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep .featureInfoDialog.p-dialog > .p-dialog-content {
  padding: 12px 14px !important;
  margin: 0 !important;
  background: #ffffff;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  flex: 1 1 auto !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist {
  padding: 0 !important;
  margin: 0 !important;
  border-bottom: 1px solid #d6d6d6 !important;
  background: #f0f0f0 !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist-nav-container {
  display: flex !important;
  align-items: stretch !important;
  gap: 6px !important;
  padding: 0 6px !important;
  height: 40px !important;
  min-height: 40px !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist-nav-content {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  height: 100% !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist-nav {
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: stretch !important;
  height: 100% !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tab {
  height: 100% !important;
  margin: 0 !important;
  padding: 0 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 10px !important;
  background: #f0f0f0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  color: #5a5c5b !important;
  box-shadow: none !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tab:hover {
  background: #e6e6e6 !important;
  outline: none !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tab[aria-selected=true],
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tab.p-tab-active,
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tab.p-highlight {
  background: #d0d0d0 !important;
  color: #4a4a4a !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tabpanels {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  height: 100% !important;
  overflow: hidden !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tabpanel {
  padding: 0 !important;
  height: 100%;
  min-height: 0 !important;
  overflow: hidden !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .fiTabHeader {
  display: inline-flex !important;
  align-items: center !important;
  gap: 10px !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .fiTabClose {
  all: unset;
  cursor: pointer;
  opacity: 0.6;
  padding: 0 2px;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .fiTabClose:hover {
  opacity: 1;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist-prev-button,
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist-next-button {
  flex: 0 0 44px !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #f7f7f7 !important;
  border: 1px solid #d0d0d0 !important;
  border-radius: 8px !important;
  outline: none !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18) !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist-prev-button > button,
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist-next-button > button {
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  outline: none !important;
  box-shadow: none !important;
}
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist-prev-button:disabled,
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist-next-button:disabled,
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist-prev-button.p-disabled,
:host ::ng-deep .featureInfoDialog .compact-tabs .p-tablist-next-button.p-disabled {
  display: none !important;
}
.panelLayout {
  height: 100%;
  min-height: 0;
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto auto;
  gap: 12px;
}
.contentArea {
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.panelLayout.street-active {
  grid-template-rows: minmax(0, 1fr) 360px auto;
}
.infoScroll {
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
}
.streetFrame {
  display: block;
  width: 100% !important;
  height: 100% !important;
  border: 0;
}
.infoTable {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
.infoTable td,
.infoTable th {
  border: 1px solid #e2e2e2;
  padding: 8px 10px;
}
.infoTable td.attName {
  width: 40%;
  font-weight: 600;
}
.infoTable td.attValue {
  width: 60%;
  color: #5a5c5b;
}
.infoTable tr:nth-child(even) {
  background: #f7f7f7;
}
.infoTable tr:hover {
  background: #eef7f1;
}
.easBtn {
  cursor: pointer;
  background: transparent !important;
  border: 1px solid #9dcaae !important;
  color: #89bf98 !important;
  border-radius: 6px !important;
  padding: 6px 10px !important;
  font-weight: 600;
  transition: all 0.2s ease;
}
.easBtn:hover {
  background: #f2fbf5 !important;
  filter: brightness(0.97);
}
.easBtn.active-dh-btn {
  background-color: #cfddd4 !important;
  border-color: #6aa47d !important;
  color: #ffffff !important;
}
.easBtn.active-dh-btn:hover {
  filter: brightness(0.95);
}
.easBtn:focus,
.easBtn:active,
.easBtn:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
.streetWrap {
  min-height: 0;
  height: 100%;
  overflow: hidden;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  background: #fff;
}
.actionRow {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 10px;
  border-top: 1px solid #efefef;
  background: #fff;
}
.infoTable td.attType,
.infoTable th.attType {
  width: 130px;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
}
.clickableCell {
  cursor: pointer;
  color: #000 !important;
  text-decoration: underline;
}
.clickableCell:hover {
  color: #000 !important;
  text-decoration: underline;
}
/*# sourceMappingURL=feature-info.component.css.map */
